module.exports = __webpack_public_path__ + "img/aboutUs.130feace.png";